export default __webpack_public_path__ + "static/media/Commander's Helm of Dynastic Rule.b71d8ad3.jpg";